import React from 'react';
import PropTypes from 'prop-types';


const SaleIcon = function SaleIconComponent({ display, className }) {
  if (!display) {
    return null;
  }
  return (
    <div className={`${className} sale-icon`}>Sale</div>
  );
};

SaleIcon.propTypes = {
  display: PropTypes.bool,
  className: PropTypes.string,
};
SaleIcon.defaultProps = {
  display: false,
  className: '',
};

export default SaleIcon;
